import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {BusinessUnitTabs} from "./BusinessUnitTabs";
import {BusinessUnitHeader} from "./BusinessUnitHeader";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';
import { BudgetHistoryPanel } from '../budget_history/BudgetHistoryPanel';

class BusinessUnitBudgetHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            budgets: []
        }
    }

    componentDidMount() {
        this.getBudgetHistory();
    }

    getBudgetHistoryUrl() {
        return `${API_URL}business-unit/${this.props.match.params.id}/budget-history`
    }

    getBudgetHistory() {
        new APIClient(this.getBudgetHistoryUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    'budgets': response.data,
                });
            }
        })
    }

    render() {
        const { t } = this.props;
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <section className="section-content">
                    <BusinessUnitHeader businessUnitId={this.props.match.params.id}/>
                    <BusinessUnitTabs
                        businessUnitId={this.props.match.params.id}
                        activeTab="-third"
                    />
                    <div className="section-body h-items">
                        <div className="section-body-item -wider box">
                            <header className="box-header">
                                <h2 className="box-title">{t('business_unit_budget_history.title')}</h2>
                            </header>
                            <BudgetHistoryPanel budgetHistory={this.state.budgets}/>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default withRouterParams(withTranslation()(BusinessUnitBudgetHistory));
